export const projectConfig={
    applicationTitle:'智慧福礼',
    applicationDescribe:'智慧福礼' ,
    applicationLogo:'@static/images/author/zhyfLogo.png'
    
}
